<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">User Report</div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        
                        <div class="col-12">
                            <FormField fieldName="Transporter_Code" :labelName="$t('group')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.GroupList"
                                    :url="this.$API_URL + 'list/group_code'" :params="{}" />
                            </FormField>

                            <FormField fieldName="CompanyList" :labelName="$t('company')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.CompanyList" 
                                    :url="this.$API_URL + 'list/company_code'" :params="{}" />
                            </FormField>

                            <FormField fieldName="PlantList" :labelName="$t('plant')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.PlantList"
                                    :url="this.$API_URL + 'list/plant'" :params="{}" />
                            </FormField>

                            <FormField fieldName="LocationList" :labelName="$t('location')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.LocationList"
                                    :url="this.$API_URL + 'list/location_code'" :params="{}" />
                            </FormField>

                            <FormField fieldName="ProductCategoryList" :labelName="$t('product_category')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.ProductCategoryList" :url="this.$API_URL + 'list/business_segment_code'"
                                    :params="{}" />
                            </FormField>

                            <FormField fieldName="CommodityList" :labelName="$t('commodity')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.CommodityList" :url="this.$API_URL + 'list/commodity_group'"
                                    :params="{}" />
                            </FormField>

                            <FormField fieldName="PurchaseOrganizationList" :labelName="$t('purchase_org')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.PurchaseOrganizationList" :url="this.$API_URL + 'list/purchase_organization'"
                                    :params="{}" />
                            </FormField>

                            <FormField fieldName="SalesOrganizationList" :labelName="$t('sales_org')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.SalesOrganizationList" :url="this.$API_URL + 'list/sales_organization_code'"
                                    :params="{}" />
                            </FormField>

                            <FormField fieldName="Distribution" :labelName="$t('distribution')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.DistributionLikst" :url="this.$API_URL + 'list/lookup'"
                                    :params="{group: this.$LOOKUP_GROUP.DISTRIBUTION}" />
                            </FormField>

                            <FormField fieldName="Is_Blocked" :labelName="$t('blocked')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <YNSelect :placeholder="$t('blocked')" :useBinary="false" v-if="header" v-model="header.Is_Blocked" />
                            </FormField>

                            <FormField fieldName="Use_AD" :labelName="$t('use_ad')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <YNSelect :placeholder="$t('use_ad')" :useBinary="false" v-if="header" v-model="header.Use_AD" />
                            </FormField>

                        </div>
                    </div>
                </div>
                <Button type="button" label="Generate" @click="getReport()" />
                &nbsp;
                <Button type="button" class="p-button-success" label="Reopen" @click="reopenTab()" v-show="this.reportTbl"/>
            </template>
        </Card>
    </form>

    <ShowReport
    :title="title"
    :isVisible="showReport"
    :reportTbl="this.reportTbl"
    @close="resetBtn()"
    />

</template>

<script>
    import ShowReport from "../Report/ShowReport.vue";
    import FormField from "../Helper/FormField.vue";
    export default {
        components: {
            ShowReport,
            FormField
        },
        data() {
            name: "UserReport";
            return {
                url: this.$API_URL + "report/",
                reportTbl: null,
                showReport:false,
                header: {
                    GroupList: [],
                    CompanyList: [],
                    PlantList: [],
                    LocationList: [],
                    ProductCategoryList: [],
                    CommodityList: [],
                    PurchaseOrganizationList: [],
                    SalesOrganizationList: [],
                    DistributionList: [],
                    Is_Blocked:"",
                    Use_AD:""
                }
            }
        },
        methods: {
            reopenTab(){
                this.showReport=true
            },
            resetBtn() {
                this.showReport = false;
            },
            getReport() {
                var self = this;
                // console.log(self.header)
                // return;
                this.$emit("blockBody");

                this.$axios.post(self.url+ "generate_user", self.header)
                    .then((response) => {
                        if(response.data.success){
                            this.reportTbl = {
                                header:response.data.data.header,
                                content:response.data.data.content,
                                title:response.data.data.title
                            }
                            this.showReport = true;
                        }else{
                            this.showError("Generate Report Error", response.data.message);
                        }
                        this.$emit("unblockBody");
                    })
                    .catch((exc) => {
                        this.$emit("unblockBody");
                    })
            },
            closeReport() {
                this.showReport = false;
            },
            showError(summary, message) {
                this.$emit('unblockBody');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
        }
    }
</script>